import React from "react"
import { IconColorsType } from "../"
import { capitalize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cleaning"
const CleaningIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`cobalt-Icon--color${capitalize(color)}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 11.4c-1.657 0-3-1.347-3-3.009C3 6.385 6 3 6 3s3 3.385 3 5.391A3.004 3.004 0 0 1 6 11.4Zm12 0c-1.657 0-3-1.347-3-3.009C15 6.385 18 3 18 3s3 3.385 3 5.391a3.004 3.004 0 0 1-3 3.009Zm-6 10c-1.657 0-3-1.347-3-3.009C9 16.385 12 13 12 13s3 3.385 3 5.391a3.004 3.004 0 0 1-3 3.009Z"
      />
    </svg>
  )
}
export default CleaningIcon
